.now {
  top: -15px;
  bottom: 0;
  position: absolute;
  pointer-events: none;
}

.nowline {
  height: 100%;
  border-left: 2px dashed var(--color-feedback-warning-400);
}

.nowtag {
  top: -6px;
  left: 0;
  color: white;
  background: var(--color-feedback-warning-400);
  position: absolute;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  transform: translate(-50%, -50%);
}

.nowtag-triangle {
  position: absolute;
  top: -6px;
  left: 0.8px;
  width: 0;
  height: 0;
  transform: translate(-50%, -50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 11px solid var(--color-feedback-warning-400);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1RpbWVsaW5lL3BhcnRpYWxzIiwic291cmNlcyI6WyJUaW1lbGluZU5vdy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5ub3cge1xuICB0b3A6IC0xNXB4O1xuICBib3R0b206IDA7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG59XG5cbi5ub3dsaW5lIHtcbiAgaGVpZ2h0OiAxMDAlO1xuICBib3JkZXItbGVmdDogMnB4IGRhc2hlZCB2YXIoLS1jb2xvci1mZWVkYmFjay13YXJuaW5nLTQwMCk7XG59XG5cbi5ub3d0YWcge1xuICB0b3A6IC02cHg7XG4gIGxlZnQ6IDA7XG4gIGNvbG9yOiB3aGl0ZTtcbiAgYmFja2dyb3VuZDogdmFyKC0tY29sb3ItZmVlZGJhY2std2FybmluZy00MDApO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGZvbnQtc2l6ZTogMTBweDtcbiAgcGFkZGluZzogMnB4IDZweDtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtNTAlKTtcbn1cblxuLm5vd3RhZy10cmlhbmdsZSB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAtNnB4O1xuICBsZWZ0OiAwLjhweDtcbiAgd2lkdGg6IDA7XG4gIGhlaWdodDogMDtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG4gIGJvcmRlci1sZWZ0OiA4cHggc29saWQgdHJhbnNwYXJlbnQ7XG4gIGJvcmRlci1yaWdodDogOHB4IHNvbGlkIHRyYW5zcGFyZW50O1xuICBib3JkZXItdG9wOiAxMXB4IHNvbGlkIHZhcigtLWNvbG9yLWZlZWRiYWNrLXdhcm5pbmctNDAwKTtcbn0iXX0= */